import React, { useState, useEffect } from 'react';
import Layout from '../../layouts/Layout';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { FaSearch, FaEdit, FaTrash } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import Loader from '../components/Loader';
import Swal from 'sweetalert2';
import { deleteBlogAPI, getBlogListAPI } from '../../services/api/BlogAPI';

const Blogs = () => {
    const navigate = useNavigate();
    const [blogs, setBlogs] = useState([]);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const user = useSelector((state) => state.LoginReducer.authData);
    const token = user.data.token;

    const onGlobalFilterChange = (e) => {
        setGlobalFilterValue(e.target.value);
    };

    useEffect(() => {
        fetchCategoriesList();
    }, []);

    const fetchCategoriesList = async () => {
        try {
            const data = await getBlogListAPI(token);
            if(data.status){
                setBlogs(data.data);
            }
        } catch (error) {
            console.error('Error fetching user list:', error);
        } finally {
            // setLoading(false);
        }
    };

    const handleEdit = (id) => {
        navigate(`/blogs/edit-blog/${id}`);
    };
    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
        });
    
        if (result.isConfirmed) {
            try {
                const data = await deleteBlogAPI(id, token);
                if(data.status){
                    fetchCategoriesList();
                    Swal.fire(
                        'Deleted!',
                        'Blog has been deleted.',
                        'success'
                    );
                }
            } catch (error) {
                Swal.fire(
                    'Error!',
                    'Something went wrong please try again.',
                    'error'
                );
            }
        }
    };

    // if (loading) {
    //     return <Loader />;
    // }

    return (
        <Layout title="Blogs">
            <div className="container table-container">
            <div className='d-flex justify-content-between'> 
                    <div className="mb-2  custom-input-group">
                        <FaSearch className="search-icon" />
                        <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" className="flex-grow-1" />
                    </div>
                    <div className="">
                        <Link to={'/blogs/create-blog'} className='btn btn-primary'>Add Blog</Link>
                    </div>
                </div>
                <DataTable value={blogs} paginator rows={10} sortField="name" sortOrder={1} removableSort stripedRows globalFilter={globalFilterValue} rowsPerPageOptions={[10, 25, 50, 100]} emptyMessage={<span className="custom-empty-message">No records found</span>} >
                    <Column field="id" header="ID" sortable></Column>
                    <Column header="Image"
                        body={(category) => (
                            <img src={category.image} alt={category.name} style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
                        )}>
                    </Column>
                    <Column field="title" header="Title" sortable></Column>
                    <Column 
                        header="Actions" 
                        body={(rowData) => (
                            <div className='d-flex gap-2 align-items-center'>
                                <button onClick={() => handleEdit(rowData.id)} className="btn btn-warning edit"><FaEdit className='' /></button>
                                <button onClick={() => handleDelete(rowData.id)} className="btn btn-danger delete"><FaTrash className='' /></button>
                            </div>
                        )}>
                    </Column>
                </DataTable>
            </div>
        </Layout>
    )
}

export default Blogs